import React from 'react';
import { Edit2Liner18 } from "../../icons";
import { IconButton } from "../IconButton";
import { Typography } from "../Typography";
import styles from "./MobileTextField.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MobileSummaryCard(props) {
  const {
    testId,
    title,
    body,
    titleTestId,
    bodyTestId,
    editButtonTestId,
    onEdit,
    disabled
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    "data-testid": testId,
    children: [/*#__PURE__*/_jsxs(Typography, {
      ellipsis: true,
      className: styles.content,
      children: [/*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        testId: titleTestId,
        children: title
      }), /*#__PURE__*/_jsx(Typography, {
        testId: bodyTestId,
        children: body
      })]
    }), !disabled && /*#__PURE__*/_jsx(IconButton, {
      noPadding: true,
      size: "smallMedium",
      className: styles.editButton,
      onClick: onEdit,
      testId: editButtonTestId,
      children: /*#__PURE__*/_jsx(Edit2Liner18, {})
    })]
  });
}